export const projects = [
  {
    title: "Francovery",
    subtitle: "React & GraphQL Apollo Server",
    description:
      "A website about France's administrative divisions. Users can view basic infos of locations, weather conditions, relevant news and photos taken at the locations.",
    image: "./francovery.png",
    link: "https://francovery-qnn.netlify.app/",
  },
  {
    title: "Make Your Meal",
    subtitle: "React Router & Spoonacular API",
    description:
      "A website provides cooking recipes where users can randomly browse recipes by topics and search for recipes by keyword.",
    image: "./cuisine.png",
    link: "https://make-your-meal-qnn.netlify.app/",
  },
  {
    title: "Game of Thrones Character Network",
    subtitle: "React & D3js",
    description:
      "A visualization for Game of Thrones character network using D3js Force-Directed Graph, where users can see the connection between the characters.",
    image: "./got-viz.png",
    link: "https://got-viz-qnn.netlify.app/",
  },
  {
    title: "Reddit Minimal",
    subtitle: "Redux & Reddit API",
    description:
      "A minimal version of Reddit, where users can select diffrents topics, view posts and read comments from other Reddit's users.",
    image: "./reddit.png",
    link: "https://reddit-minimal-qnn.netlify.app/",
  },
  {
    title: "Jammming",
    subtitle: "React & Spotify API",
    description:
      "A music app based on the Spotify API to search for songs, listen to previews, and create new playlists to your Spotify account.",
    image: "./jammming.png",
    link: "https://jammming-qnn.netlify.app/",
  },
  {
    title: "Narutopedia",
    subtitle: "React & Redux Toolkit",
    description:
      "A website provides information about Naruto's characters - the famous Japanese manga series. You can choose to view an article's details in the list.",
    image: "./narutopedia.png",
    link: "https://narutopedia-qnn.netlify.app/",
  },
  {
    title: "Matching Memory",
    subtitle: "React & Redux",
    description:
      "A classic memory game consists of 12 cards. You need to flip the cards one by one, memorize their positions to find the matching pairs.",
    image: "./memory.png",
    link: "https://matching-memory-qnn.netlify.app/",
  },
  {
    title: "Flashcard Quizzes",
    subtitle: "React & Redux Toolkit",
    description:
      "A flashcard quizzes app where you can not only participate in answering questions, but also create your own topics and questions.",
    image: "./quizzes.png",
    link: "https://flashcard-quizzes-qnn.netlify.app/",
  },
];

export const skills = [
  "HTML5/ CSS3",
  "JavaScript/ jQuery",
  "React/ Redux",
  "Sass/ Bootstrap",
  "Tailwind/ MaterialUI",
  "GraphQL Apollo",
  "TypeScript",
  "Python Django",
];
export const events = [
  {
    time: "2016",
    events: [
      "Coming to France for the first time and becoming an intern at LIGLAB-Grenoble INP.",
      "After 6 months, returning to Hanoi to graduate from the IT Engineering program.",
    ],
  },
  {
    time: "2017",
    events: [
      "Returning to France for a master's degree, completing a 6-months internship at CEA Grenoble.",
      "Graduate from the Master of Science in Informatics at Grenoble in Data Science.",
    ],
  },
  {
    time: "2018",
    events: [
      "Signing a Ph.D. contract with CEA Cadarache. However, it was canceled after 3 months due to the instructor's personal problems.",
      "Looking for a job in the field of Data Science in Grenoble but not successfully.",
    ],
  },
  {
    time: "2019",
    events: [
      "Getting married and decided to work in a Japanese restaurant in order to take care of my family.",
      "Starting as a waitress then becoming a Team Manager of 5 people after 6 months.",
    ],
  },
  {
    time: "2020",
    events: [
      "Quitting job at the restaurant, moving to Brest. Realizing that I still enjoy coding.",
      "Completing Front-End Engineer Course in order to revise knowledge and update new technologies.",
    ],
  },
  {
    time: "2021",
    events: [
      "Working on freelance and personal projects to practice Front-End programming skills.",
      "Starting a word-study contract as a Front-End developer at Swappy.",
    ],
  },
  {
    time: "2022",
    events: [
      "Improving my programming skills in ReactJS - Redux, learning new technologies like NextJs, TypeScript...",
      "Become the responsible developer for the design, development and maintenance of user interfaces.",
    ],
  },
];
